/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* Matching Box 18 */

if(document.getElementById('product_form_15886733050181')){
	document.getElementById('shopify-section-product-template').addEventListener('change', function(e){
 
  if(e.target.type == 'number'){
  	
    let inputNumber = document.querySelectorAll('input.spb-productdescfont');
    let total = 0;
    let totalMax = 18;
    let rest = 18;
    let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
 	let totalValue = 0;
    
 
    for (var i = 0; i < inputNumber.length; i++) {
    	let input = inputNumber[i];
      
      	if(!input.hasAttribute('min')){
          input.setAttribute('min', '0');
          input.setAttribute('max', '18');
          
          if (!isMobile) {
          	input.setAttribute('onkeydown', 'return false')
          }
        }
      
      	let inputValue = inputNumber[i].value;
      
      	if(inputValue >= 0){
          total = total + parseInt(inputValue);
          rest = totalMax - total;
        }
    };
    
 
     if(total == totalMax){
      
       
          for (var x = 0; x < inputNumber.length; x++) {
              totalValue = totalValue + parseInt(inputNumber[x].value);
          }
       		
              
         if(totalValue = totalMax){

           document.querySelector('.ProductForm__AddToCart').classList.add('enabled')
         }
  
         
     } else{
       document.querySelector('.ProductForm__AddToCart').classList.remove('enabled')
     }
    
   
    let restContainer = document.querySelector('.matching-box-rest-18');
    let restContainerNote =  document.querySelector('.matching-container-note');
    let matchingContainer =  document.querySelector('.matching-container');

    if(rest >= 0){
      matchingContainer.style.display = "block";
      restContainerNote.style.display = "none";
      restContainer.innerHTML = rest;
    } 


    if(rest < 0){
      matchingContainer.style.display = "none";
      restContainerNote.style.display = "block";
      restContainerNote.innerHTML = "La quantité renseignée est supérieure à la quantité prédéfinie"
    } 
    

    
  }
  
});
}

/* Matching Box 16 */

if(document.getElementById('product_form_6820092477638')){
	document.getElementById('shopify-section-product-template').addEventListener('change', function(e){
 
  if(e.target.type == 'number'){
  	
    let inputNumber = document.querySelectorAll('input.spb-productdescfont');
    let total = 0;
    let totalMax = 16;
    let rest = 16;
    let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
 	let totalValue = 0;
    
 
    for (var i = 0; i < inputNumber.length; i++) {
    	let input = inputNumber[i];
      
      	if(!input.hasAttribute('min')){
          input.setAttribute('min', '0');
          input.setAttribute('max', '16');
          
          if (!isMobile) {
          	input.setAttribute('onkeydown', 'return false')
          }
        }
      
      	let inputValue = inputNumber[i].value;
      
      	if(inputValue >= 0){
          total = total + parseInt(inputValue);
          rest = totalMax - total;
        }
    };
    
 
     if(total == totalMax){
      
       
          for (var x = 0; x < inputNumber.length; x++) {
              totalValue = totalValue + parseInt(inputNumber[x].value);
          }
       		
              
         if(totalValue = totalMax){

           document.querySelector('.ProductForm__AddToCart').classList.add('enabled')
         }
  
         
     } else{
       document.querySelector('.ProductForm__AddToCart').classList.remove('enabled')
     }
    
   
    let restContainer = document.querySelector('.matching-box-rest-16');
    let restContainerNote =  document.querySelector('.matching-container-note');
    let matchingContainer =  document.querySelector('.matching-container');

    if(rest >= 0){
      matchingContainer.style.display = "block";
      restContainerNote.style.display = "none";
      restContainer.innerHTML = rest;
    } 


    if(rest < 0){
      matchingContainer.style.display = "none";
      restContainerNote.style.display = "block";
      restContainerNote.innerHTML = "La quantité renseignée est supérieure à la quantité prédéfinie"
    } 
    

    
  }
  
});
}
/* Matching Box 8 */

if(document.getElementById('product_form_6877545300166')){
	document.getElementById('shopify-section-product-template').addEventListener('change', function(e){
 
  if(e.target.type == 'number'){
    console.log(e)
  	
    let inputNumber = document.querySelectorAll('input.spb-productdescfont');
    let total = 0;
    let totalMax = 8;
    let rest = 8;
    let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
	let totalValue = 0;
    
 
    for (var i = 0; i < inputNumber.length; i++) {
    	let input = inputNumber[i];
      
      	if(!input.hasAttribute('min')){
          input.setAttribute('min', '0');
          input.setAttribute('max', '8');
          
          if (!isMobile) {
          	input.setAttribute('onkeydown', 'return false')
          }
        }
      
      	let inputValue = inputNumber[i].value;
      
      	if(inputValue >= 0){
          total = total + parseInt(inputValue);
          rest = totalMax - total;
        }
    };
    
     if(total == totalMax){
         for (var x = 0; x < inputNumber.length; x++) {
              totalValue = totalValue + parseInt(inputNumber[x].value);
          }
       		
              
         if(totalValue = totalMax){

           document.querySelector('.ProductForm__AddToCart').classList.add('enabled')
         }
  
     } else{
       document.querySelector('.ProductForm__AddToCart').classList.remove('enabled')
     }
    
   
    let restContainer = document.querySelector('.matching-box-rest-8');
    let restContainerNote =  document.querySelector('.matching-container-note');
    let matchingContainer =  document.querySelector('.matching-container');

    if(rest >= 0){
      matchingContainer.style.display = "block";
      restContainerNote.style.display = "none";
      restContainer.innerHTML = rest;
    } 


    if(rest < 0){
      matchingContainer.style.display = "none";
      restContainerNote.style.display = "block";
      restContainerNote.innerHTML = "La quantité renseignée est supérieure à la quantité prédéfinie"
    } 
     
  }
  
});
}

/* Matching Box 4 */

if(document.getElementById('product_form_6877683613894')){
	document.getElementById('shopify-section-product-template').addEventListener('change', function(e){
 
  if(e.target.type == 'number' || document.getElementById('shopify-section-product-template')){
  
    let inputNumber = document.querySelectorAll('input.spb-productdescfont');
    let total = 0;
    let totalMax = 4;
    let rest = 4;
    let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
	let totalValue = 0;
 
    for (var i = 0; i < inputNumber.length; i++) {
    	let input = inputNumber[i];
      
      	if(!input.hasAttribute('min')){
          input.setAttribute('min', '0');
          input.setAttribute('max', '4');
          
          if (!isMobile) {
          	input.setAttribute('onkeydown', 'return false')
          }
        }
      
      	let inputValue = inputNumber[i].value;
      
      	if(inputValue >= 0){
          total = total + parseInt(inputValue);
          rest = totalMax - total;
        }
    };
    
     if(total == totalMax){
         for (var x = 0; x < inputNumber.length; x++) {
              totalValue = totalValue + parseInt(inputNumber[x].value);
          }
       		
              
         if(totalValue = totalMax){

           document.querySelector('.ProductForm__AddToCart').classList.add('enabled')
         }
  
     } else{
       document.querySelector('.ProductForm__AddToCart').classList.remove('enabled')
     }
    
    
      let restContainer = document.querySelector('.matching-box-rest-4');
	  let restContainerNote =  document.querySelector('.matching-container-note');
      let matchingContainer =  document.querySelector('.matching-container');
       
      if(rest >= 0){
        matchingContainer.style.display = "block";
        restContainerNote.style.display = "none";
      	restContainer.innerHTML = rest;
      } 
      
     
      if(rest < 0){
        matchingContainer.style.display = "none";
        restContainerNote.style.display = "block";
        restContainerNote.innerHTML = "La quantité renseignée est supérieure à la quantité prédéfinie"
      } 
      
      
    

    
  }
  
});
}

if(document.getElementById('custom-forms')){


  document.getElementById('custom-forms').addEventListener('click', function(e){
    if(e.target.type == 'file'){



      let fileInput = document.getElementById('52171-file');

      if(fileInput){
        fileInput.onchange = () => {
          let fileName = document.querySelectorAll(".file-name-container");
          if(fileName){
            for (let x = 0; x < fileName.length; x++) {
              fileName[x].remove()
            }
          }
          let selectedFiles = [...fileInput.files];
          for (let i = 0; i < selectedFiles.length; i++) {
            let paragraphContainer=document.querySelector(".globo-paragraph p");
            paragraphContainer.innerHTML += "<span class='file-name-container globo-form-control'>"+selectedFiles[i].name+"</span>"
          }
        }
      }

      let fileInput2 = document.getElementById('51892-file');
      if(fileInput2){
        fileInput2.onchange = () => {
          let fileName = document.querySelectorAll(".file-name-container");
          if(fileName){
            for (let x = 0; x < fileName.length; x++) {
              fileName[x].remove()
            }
          }
          let selectedFiles = [...fileInput2.files];
          for (let i = 0; i < selectedFiles.length; i++) {
            let paragraphContainer=document.querySelector(".globo-paragraph p");
            paragraphContainer.innerHTML += "<span class='file-name-container globo-form-control'>"+selectedFiles[i].name+"</span>"
          }
        }
      }
    }
  });

}

setTimeout(function() {
  var picto = document.querySelector('.recette-page-image');
  if (picto) {
    picto.style.setProperty('display', 'none', 'important');
  }
}, 1000);
